// Layout component with header and footer matching dioschub.com

import React from 'react';
import { Linkedin } from 'lucide-react';

interface LayoutProps {
  children: React.ReactNode;
}

export function Layout({ children }: LayoutProps) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Header */}
      <header className="bg-background/80 backdrop-blur-md border-b border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center h-16">
            <img
              src="/images/logo-dark.png"
              alt="Dioschub"
              className="h-8 w-auto"
            />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 py-10 sm:px-6 lg:px-8">
          {children}
        </div>
      </main>

      {/* Footer */}
      <footer className="py-12 border-t border-border">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="flex items-center gap-4">
              <img
                src="/images/logo-dark.png"
                alt="Dioschub"
                className="h-7 w-auto"
              />
            </div>

            <div className="flex items-center gap-6 text-sm text-muted-foreground">
              <a
                href="mailto:DioschubDemo@intrigsoft.com"
                className="hover:text-foreground transition-colors"
              >
                DioschubDemo@intrigsoft.com
              </a>
              <a
                href="https://www.linkedin.com/company/101707302/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-foreground transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
            </div>

            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} Intrigsoft (Pvt) Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
